module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/sola_link_image_plan-526fac4ee3b6d57f7d66d3073b2250a1.jpg";